import { createContext, useContext } from 'react';
import * as setup from 'setup';

const defaultData = {
    footer: setup.footer,
    general: setup.general,
    header: setup.header,
    landing: setup.landing,
    popups: setup.popups,
    simulation: setup.simulation.content,
};

const ContentContext = createContext<ContentState>({} as ContentState);

export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }: ContentProviderProps) {
    return <ContentContext.Provider value={defaultData}>{children}</ContentContext.Provider>;
}
